import { connect } from 'react-redux';
import PhotoManager from './Photo_manager';
import { setModalMessage, setModalTitle, setAndOpenModal } from '../../Modal/modal_actions';

const mDTP = { setModalMessage, setModalTitle, setAndOpenModal };

export default connect(null, mDTP)(PhotoManager);
